<template>
  <div class="chart-container">
    <span class="middle-text">
      <slot></slot>
    </span>
    <canvas ref="chart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: {
    datasets: Array,
  },
  data: () => ({
    chart: null,
    load: false,
    configuration: {
      type: "doughnut",
      data: {
        datasets: [
          { backgroundColor: ["#A5B0C066"], data: [1], borderWidth: 0 },
        ],
      },
      options: {
        events: [], // removes hover effect, could cause side effects
        cutoutPercentage: 70,
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
      },
    },
  }),
  watch: {
    datasets: {
      handler(val) {
        this.addDataset(val);
      },
    },
  },
  mounted() {
    const ctx = this.$refs.chart;
    this.chart = new Chart(ctx, this.configuration);
  },
  methods: {
    addDataset(datasets) {
      this.load = datasets.length === this.configuration.data.datasets.length;
      if (this.load) {
        datasets.forEach((dataset, index) => {
          this.configuration.data.datasets[index].backgroundColor =
            dataset.backgroundColor;
          this.configuration.data.datasets[index].data = dataset.data;
        });
      } else {
        this.configuration.data.datasets = datasets;
        this.load = true;
      }
      this.chart.update();
    },
  },
};
</script>

<style scoped>
.chart-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.middle-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>